import styled, { css } from 'styled-components';

export default css`
  &.search-tile-layout {
    position: relative;
  }
  .stackImg {
    height: 106px;
    border-radius: 6px;
    box-shadow: 2px 2px 10px 0 rgba(195, 195, 195, 0.5);
  }
  .prev-search-redesign {
    width: 160px;
    height: auto;
    @media (min-width: 1200px) and (max-width: 1300px) {
      width: 111px;
    }
    @media (min-width: 1300px) and (max-width: 1500px) {
      width: 126px;
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      width: 230px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 94px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 114px;
      max-width: 114px;
    }
  }
  .prev-img-0 {
    position: relative;
    z-index: 3;
  }
  .prev-img-1 {
    position: absolute;
    top: 5px;
    left: 6px;
    z-index: 2;
  }
  .prev-img-2 {
    position: absolute;
    top: 11px;
    left: 13px;
    z-index: 1;
  }
  .img-search {
    left: 56px;
    bottom: 87px;
    right: 16.6px;
    width: 25.5px;
    height: 27.5px;
    position: absolute;
    z-index: 5;
  }
  .product-text-container {
    display: flex;
    width: 105px;
    height: 57px;
    margin: 12px 0 0;
    ${(props) =>
      props.searchEnhancementRedesign &&
      `
      width:auto; max-width: 126px;
    `}
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      ${(props) =>
        props.searchEnhancementRedesign &&
        `
        width:auto; max-width: 176px;
      `}
    }
  }
  .search-tcp-1,
  .search-tcp-2 {
    stroke: #9b9b9b;
  }
  .product-search-text {
    text-transform: capitalize;
    ${(props) =>
      props.searchEnhancementRedesign &&
      `
      font-size: ${props.theme.typography.fontSizes.fs12};
    `}
  }
`;

export const StyledImageContainer = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;
